<template>
	<div >
		<div >
			<ShouyeTop></ShouyeTop>
		</div>
		<div >
			<Chart></Chart>
		</div>
		<div >
			<shouyeBottom></shouyeBottom>
		</div>
	</div>
</template>

<script>
	import shouyeBottom from './ShouyeBottom.vue'
	import shouyeWork from './ShouyeWork.vue'
	import Chart from './Chart.vue'
	import ShouyeTop from './ShouyeTop.vue'
	export default{
		name:"Shouye",
		components:{ShouyeTop,Chart,shouyeBottom,shouyeWork},
		data() {
			return {
				topData: {}
			}
		},
		methods: {
		}
	}
</script>

<style scoped lang="less">
	.shoye-top,.shoye-center,.shoye-bottom{
		margin: 0 auto;
		width: 100%;
		
	}
	
</style>
